import { RemoteGetMenu } from 'data/usecases';
import { GetMenu } from 'domain/usecases';
import { makeApiUrlMenu } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetMenu = (): GetMenu =>
  new RemoteGetMenu(makeApiUrlMenu(), makeAxiosHttpClient());
